import { IPasswordChangeRequest, IUser } from '@epicuro-next/data/users';
import { createAction, props } from '@ngrx/store';

export const loadUser = createAction('[User] Load user');
export const loadUserSuccess = createAction(
  '[User] Load user success',
  props<{ user: IUser }>(),
);
export const loadUserFailure = createAction(
  '[User] Load user Failure',
  props<{ error: string }>(),
);

export const login = createAction(
  '[Session] Login',
  props<{ username: string; password: string }>(),
);

export const loginSuccess = createAction('[Session] Login Success');

export const loginFailure = createAction(
  '[Session] Login Failure',
  props<{ error: string }>(),
);

export const logout = createAction('[Session] Logout');

export const forgotPassword = createAction(
  '[Session] Forgot password',
  props<{ username: string }>(),
);

export const resetPassword = createAction(
  '[Session] Reset password',
  props<{ payload: IPasswordChangeRequest }>(),
);

export const resetPasswordFailed = createAction(
  '[Session] Reset password failed',
  props<{ errors: string[] }>(),
);
